import type React from 'react';
import { Button } from '@itandi/itandi-bb-ui';

export const renderSearchButton = (
  handleDetailSearch: () => Promise<void>
): React.ReactElement => (
  <Button onClick={handleDetailSearch} variant="primary">
    検索
  </Button>
);
